import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './index.scss';
import Popover from '@/components/Popover';
import SpiderWebEntrance from '../SpiderWebEntrance';
import { AnyFunc } from '@/utils/types';
import { addGlobalEventListener } from '@/utils/emit';
import { SHOW_SPIDER_WEB_NAVBAR } from '@/utils/constant';
import {
  ExtraEntranceInfoContext,
  SpiderWebNavbarInfo
} from '../../utils/type';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { getRequestHeader } from '@/fetch/business/base';

/**
 * 显示三个点入口的条件配置
 * 后续有别的逻辑，在此添加
 */
const ShowThreePointEntryConditionList: Array<
  (ctx: ExtraEntranceInfoContext) => boolean
> = [
  (ctx: ExtraEntranceInfoContext) =>
    Boolean(
      (ctx.isSpiderWebSingleVehicle || ctx.isGeneralTransportSingleVehicle) &&
        ctx.spiderWebNavbarInfo?.showExtraEntry
    )
];

interface PopoverContentProps {
  setPopoverVisible: AnyFunc;
  extraEntranceInfoContext: ExtraEntranceInfoContext;
}

/**
 * 弹出层内容
 * 后续有新的入口在此添加
 * @param {PopoverContentProps} props
 * @return {*}
 */
function PopoverContent(props: PopoverContentProps) {
  const { setPopoverVisible, extraEntranceInfoContext } = props;
  return (
    <>
      <SpiderWebEntrance
        setPopoverVisible={setPopoverVisible}
        extraEntranceInfoContext={extraEntranceInfoContext}
      />
    </>
  );
}

/**
 * “三个点”的按钮入口
 * @return {*}
 */
function ExtraFunctionEntrance() {
  const location = useLocation();
  // 获取当前路由是否是蜘蛛网单车页面
  const isSpiderWebSingleVehicle =
    (location.pathname &&
      location.pathname.includes('/spider-web/singleVehicle')) ||
    false;
  // 获取当前路由是否是点对点接驳单车页面
  const isGeneralTransportSingleVehicle =
    (location.pathname &&
      location.pathname.includes('/general-transport/singleVehicle')) ||
    false;

  const [visible, setVisible] = useState(false); // 弹出层是否显示
  // 蛛网入口的数据
  const [spiderWebNavbarInfo, setSpiderWebNavbarInfo] =
    useState<SpiderWebNavbarInfo>({
      showExtraEntry: false,
      vehicleIssueType: null,
      getVehicleRealtimeInfo: undefined
    });
  const [showExtraFunctionEntrance, setShowExtraFunctionEntrance] =
    useState(false);
  const checkSite = async () => {
    const requestOptions: RequestOptions = {
      absoluteURL: process.env.JDX_APP_LOP_DOMAIN! + '/schedule/h5/checkSite',
      method: 'POST',
      headers: getRequestHeader()
    };
    const res = await request(requestOptions);
    if (res?.code === HttpStatusCode.Success) {
      setShowExtraFunctionEntrance(res.data);
    } else {
      setShowExtraFunctionEntrance(false);
    }
  };
  useEffect(() => {
    if (
      location.pathname.includes('/spider-web/singleVehicle') ||
      location.pathname.includes('/general-transport/singleVehicle')
    ) {
      checkSite();
    } else {
      setShowExtraFunctionEntrance(false);
    }
  }, [location.pathname]);
  /**
   * 蛛网入口的监听设置
   */
  useEffect(() => {
    // 当需要展示蛛网入口时，更新数据
    const updateShowSpiderWebNavbar = (options: any) => {
      const { show, vehicleIssueType, getVehicleRealtimeInfo } = options;
      setSpiderWebNavbarInfo({
        showExtraEntry: show || false,
        vehicleIssueType: vehicleIssueType || null,
        getVehicleRealtimeInfo: getVehicleRealtimeInfo
      });
    };
    // 监听蜘蛛网入口的显示
    addGlobalEventListener(SHOW_SPIDER_WEB_NAVBAR, updateShowSpiderWebNavbar);

    // 清理函数
    return () => {
      removeEventListener(SHOW_SPIDER_WEB_NAVBAR, updateShowSpiderWebNavbar);
    };
  }, []);

  /**
   * 公共的入口数据上下文
   */
  const extraEntranceInfoContext: ExtraEntranceInfoContext = {
    isGeneralTransportSingleVehicle,
    isSpiderWebSingleVehicle,
    spiderWebNavbarInfo
  };

  /**
   * 是否显示“三个点”的按钮入口
   * 遍历条件，若满足任意一个条件则返回true
   */
  const shouldShowThreePointEntry = useMemo(() => {
    return ShowThreePointEntryConditionList.some((fn) =>
      fn(extraEntranceInfoContext)
    );
  }, [extraEntranceInfoContext]);

  return (
    <>
      {shouldShowThreePointEntry && showExtraFunctionEntrance && (
        <Popover
          visible={visible}
          content={
            <PopoverContent
              setPopoverVisible={setVisible}
              extraEntranceInfoContext={extraEntranceInfoContext}
            />
          }
          placement="top-end"
          trigger="click"
          onVisibleChange={(v) => setVisible(v)}
        >
          <div className="extra-btn">
            <span className="round-btn"></span>
            <span className="round-btn"></span>
            <span className="round-btn"></span>
          </div>
        </Popover>
      )}
    </>
  );
}

export default ExtraFunctionEntrance;
